import { ArrowBack } from '@mui/icons-material';
import { Checkbox, CircularProgress, Divider, Link, Stack, Typography } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { useNavigate } from 'react-router';

interface Props {
  isLoading: boolean;
  conditionsLength: number;
  indeterminate: boolean;
  allSupplierCheckboxSelected: boolean;
  handleAllSupplierCheckbox: () => void;
}

export function ApprovalToolbar({
  isLoading,
  conditionsLength,
  indeterminate,
  allSupplierCheckboxSelected,
  handleAllSupplierCheckbox,
}: Props) {
  const t = useAppTFunction();
  const navigate = useNavigate();

  return (
    <>
      <Link
        color="text.primary"
        onClick={() => navigate(-1)}
        alignSelf="flex-start"
        sx={{
          '&:hover': {
            cursor: 'pointer',
          },
        }}
      >
        <Stack flexDirection="row" alignItems="center" p={1.5}>
          <ArrowBack fontSize="small" /> {t('common.goBack')}
        </Stack>
      </Link>

      <Stack justifyContent="center" pb={1.5} pl={0.75} mt={0.5}>
        <Stack flexDirection="row" alignItems="center" gap={0.5}>
          <Checkbox
            sx={{
              width: indeterminate ? 38 : undefined,
              height: indeterminate ? 38 : undefined,
            }}
            indeterminate={indeterminate}
            checked={allSupplierCheckboxSelected}
            onChange={handleAllSupplierCheckbox}
          />

          <Typography variant="subtitle2" ml={1}>
            {isLoading ? <CircularProgress size={18} /> : conditionsLength}
          </Typography>
          <Typography variant="body2">
            {conditionsLength === 1
              ? t('calculus.conditionToApproval')
              : t('calculus.conditionsToApproval')}
          </Typography>
        </Stack>
      </Stack>

      <Divider />
    </>
  );
}
